<template>
  <div id="map">
    <!--In the following div the HERE Map will render-->

    <div id="mapContainer" style="height:200px;width:100%;font-family:'Courier New', Courier, monospace" ref="hereMap"
      class="grey">
      <div style="padding-left: 10px;">Latitude:{{ lat }} Longitude:{{ lon }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HereMap",
  props: {
    center: Object
    // center object { lat: 40.730610, lng: -73.935242 }
  },
  data() {
    return {
      platform: null,
      lat: null,
      lon: null,
      apikey: "MO86dh7QoyCt4OBp4Mu6uHN878TLdQ_TNAI3lKUC4_Q"
      // You can get the API KEY from developer.here.com
    };
  },
  async mounted() {
    // Initialize the platform object:
    const platform = new window.H.service.Platform({
      apikey: this.apikey
    });
    this.platform = platform;
    this.initializeHereMap();
  },
  methods: {

    initializeHereMap() { // rendering map

      const mapContainer = this.$refs.hereMap;
      const H = window.H;
      // Obtain the default map types from the platform object
      var maptypes = this.platform.createDefaultLayers();

      // Instantiate (and display) a map object:
      var map = new H.Map(mapContainer, maptypes.vector.normal.map, {
        zoom: 18,
        center: this.center,
        // center object { lat: 40.730610, lng: -73.935242 }
      });

      this.lat = Object.values(this.center)[0];
      this.lon = Object.values(this.center)[1];


      // Create an icon, an object holding the latitude and longitude, and a marker:

      var center = this.center;
      var marker = new H.map.Marker(center);

      // Add the marker to the map and center the map at the location of the marker:
      map.addObject(marker);
      map.setCenter(center);

      // add behavior control
      // new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
      // add UI
      var ui = H.ui.UI.createDefault(map, maptypes);
      var mapSettings = ui.getControl('mapsettings');

      let menuEntries = mapSettings.getChildren()[1].getChildren();
      menuEntries[0].getElement().style.borderBottom = 'none';
      for (let i = 1; i < menuEntries.length; i++)
        menuEntries[i].setVisibility(false);
      // End rendering the initial map
    }
  }
};
</script>

<style scoped></style>